import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { IExpenseBanksDto } from "../dtos/IExpenseBanksDto";
import { IExpenseBanksModel } from "../models/IExpenseBanksModel";
import { ExpenseBanksService } from "src/services/documents/ExpenseBanksService";
import { AppEntities } from "src/config/entities";
import { IExpenseBankPaymentDto } from "../dtos/IExpenseBankPaymentDto";

interface IProps {
  documentId?: string;
}

export const useFetchExpenseBankPayments = ({ documentId }: IProps) => {
  const [isDocumentLoading, setIsDocumentLoading] = useState(false);
  const [documentDto, setDocumentDto] = useState<IExpenseBanksDto | null>(null);
  const [documentModel, setDocumentModel] = useState<IExpenseBanksModel | null>(null);
  const dataService = AppEntities.ExpenseBankPayments.getDataService() as ExpenseBanksService;

  const postDocument = async () => {
    if (!documentId) return;
    await dataService.PostDocument(documentId);
    toast.success("Document posted successfully");
  };

  const cancelDocument = async () => {
    if (!documentId) return;
    await dataService.CancelDocument(documentId);
    toast.success("Document canceled successfully");
  };

  const updateDocument = async (documentModel: IExpenseBanksModel) => {
    if (!documentId) return;
    console.log(documentModel);
    const requestDto: IExpenseBanksDto = { ...documentModel };
    const responseDto = await dataService.Update(requestDto);
    setDocumentDto(responseDto);
    // toast.success("Document updated successfully");
  };

  const fetchDocument = async () => {
    try {
      setIsDocumentLoading(true);

      let responseDto: IExpenseBanksDto | null = null;
      let responsePaymentsDto: IExpenseBankPaymentDto[] = [];

      if (!documentId) {
        responseDto = await dataService.Create({
          documentDate: new Date()
        });
        setDocumentDto(responseDto);
      } else {
        responseDto = await dataService.Get(documentId);
        setDocumentDto(responseDto);
      }

      if (!responseDto) return;

      const newModel: IExpenseBanksModel = {
        ...responseDto,
        payments: [...responsePaymentsDto]
      };
      setDocumentModel(newModel);
    } catch (e) {
      console.log(e);
    } finally {
      setIsDocumentLoading(false);
    }
  };

  useEffect(() => {
    fetchDocument();
  }, [documentId]);

  return {
    isDocumentLoading,
    documentDto,
    documentModel,
    postDocument,
    cancelDocument,
    updateDocument
  };
};
